import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AccordionDetails, Typography } from "@mui/material";
import { getUserWiseBankDetails } from "../../store/actions";

const BankUpdateDetail = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserWiseBankDetails());
  }, []);

  const getUserWiseBankDetailsResponse = useSelector(
    (state) => state.bankUpdateDetail.getUserWiseBankDetails.responseData
  );

  console.log("bankUpdateDetailSagas", getUserWiseBankDetailsResponse);
  return (
    <>
      {getUserWiseBankDetailsResponse &&
        getUserWiseBankDetailsResponse.map((data, index) => {
          return (
            <div className="row">
              <div className="col-lg-12 mt-4 d-flex">
                {0 == data?.bankStatus ? (
                  <form
                    action="https://demo.b2biz.co.in/TeaBoard/ws/registerBankInfo"
                    method="post"
                  >
                    <input
                      type="hidden"
                      name="walletClientCode"
                      value="WT-1001"
                    />

                    <input
                      type="hidden"
                      name="walletRequestMessage"
                      value={data?.createWalletRequestMessage}
                    />

                    <label>{data?.userCode}</label>
                    <button className="SubmitBtn ml-3" type="submit">
                      Register With Bank
                    </button>
                  </form>
                ) : 1 == data?.bankStatus ? (
                  <>
                    <form
                      action="https://demo.b2biz.co.in/TeaBoard/ws/modifyBankInfo"
                      method="post"
                    >
                      <input
                        type="hidden"
                        name="walletClientCode"
                        value="WT-1001"
                      />

                      <input
                        type="hidden"
                        name="walletRequestMessage"
                        value={data?.updateWalletRequestMessage}
                      />
                      <label>
                        <span style={{ marginRight: '20px' }}>{data?.markCode}</span>
                        <span style={{ marginRight: '20px' }}>{data?.markName}</span>
                        <span>{data?.userCode}</span>
                      </label>
                      <button className="SubmitBtn ml-3" type="submit">
                        Update Bank Details
                      </button>
                    </form>

                    <form
                      action="https://demo.b2biz.co.in/TeaBoard/ws/viewBankInfo"
                      method="post"
                    >
                      <input
                        type="hidden"
                        name="walletClientCode"
                        value="WT-1001"
                      />

                      <input
                        type="hidden"
                        name="walletRequestMessage"
                        value={data?.viewWalletRequestMessage}
                      />

                      <button className="SubmitBtn ml-3" type="submit">
                        View Bank Details
                      </button>
                    </form>
                  </>
                ) : (
                  ""
                )}{" "}
              </div>
            </div>
          );
        })}
    </>
  );
};

export default BankUpdateDetail;
